import { FC, useMemo } from 'react';
import { MiniSpinner } from '../styles/Spinner';
import { useDetectFlagChange } from '../../requests/flag-change';
import constants from '../constants';
import TableContainer from '@mui/material/TableContainer';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const FlagChangeDetector: FC<{ mmsi: string; timePoint: FlagChangeProps[] }> = ({ mmsi, timePoint }) => {
    const {
        data: postFlagChangeData,
        isLoading: postIsLoading,
        isError: postIsError,
    } = useDetectFlagChange(mmsi, timePoint[0], 'backward');
    const {
        data: preFlagChangeData,
        isLoading: preIsLoading,
        isError: preIsError,
    } = useDetectFlagChange(mmsi, timePoint[1], 'forward');

    const flagChangeData: FlagChangeResponse[] | undefined = useMemo(() => {
        const pre = !preIsLoading && !preIsError ? preFlagChangeData : [];
        const post = !postIsLoading && !postIsError ? postFlagChangeData : [];
        return [...pre!, ...post!];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [postFlagChangeData, preFlagChangeData]);

    if (postIsLoading) {
        return (
            <div className={`flex justify-between ${constants.colors.pallet.lightBlack}`}>
                <MiniSpinner size={36} />
            </div>
        );
    } else if (postIsError) {
        return <div>Something went wrong fetching data</div>;
    } else if (flagChangeData && flagChangeData.length > 0) {
        return (
            <>
                {(preIsLoading || postIsLoading) ?? (
                    <div className={`flex justify-between ${constants.colors.pallet.lightBlack} z-1000`}>
                        <MiniSpinner size={36} />
                    </div>
                )}

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 450 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Unique MMSI</TableCell>
                                <TableCell align="right">IMO</TableCell>
                                <TableCell align="right">Vessel name</TableCell>
                                <TableCell align="right">Timestamp of last message</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {flagChangeData.map((row) => (
                                <TableRow
                                    key={row.timestamp}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.mmsi}
                                    </TableCell>
                                    <TableCell align="right">{row.imo}</TableCell>
                                    <TableCell align="right">{row.vesselName}</TableCell>
                                    <TableCell align="right">{row.timestamp}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        );
    } else {
        return <div>No flag change detected</div>;
    }
};

const FlagChangeButton: FC<{ mmsi: string | null; timePoint: FlagChangeProps[] | null }> = ({ mmsi, timePoint }) => {
    if (!timePoint) {
        return <div>Something went wrong getting ais point</div>;
    } else if (!mmsi) {
        return <div>mmsi not set</div>;
    }
    return <FlagChangeDetector mmsi={mmsi} timePoint={timePoint} />;
};

export default FlagChangeButton;
